var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"commit-component"},[_c('span',{staticClass:"commit-component-icon"}),_c('span',{staticClass:"commit-component-number"},[_vm._v(_vm._s(_vm.commitNumber))])])}
var staticRenderFns = []

export { render, staticRenderFns }